import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DocumentTypeUse/All', method: 'GET', body: null, token: token })
}
